import React from "react";
import PropTypes from "prop-types";
import { TextField, Button } from "@mui/material";
import SnackbarAlert from "../SnackbarAlert";

const LoginTemplate = ({
                         showForgotPassword,
                         messageData,
                         onMessageClose,
                         userName,
                         setUserName,
                         password,
                         setUserPassword,
                         setIsForgotPassword,
                         submitLogin,
                         img,
                         loginPageTitle
}) => {
  return (
    <div>
      <img
        id="logologin"
        src={img}
        alt="DrOwl"
      />
      <h2 className="windowTitl">{loginPageTitle}</h2>
      <TextField
        id="username"
        className="loginInput"
        variant="outlined"
        label="Username"
        value={userName}
        onChange={(e) =>
          setUserName(e.target.value)}
      />
      <br/><br/>
      <TextField
        id="password"
        className="loginInput"
        type="password"
        variant="outlined"
        label="Password"
        value={password}
        onChange={(e) =>
          setUserPassword(e.target.value)}
      />
      <br/><br/>
      <br/>
      <div style={{display: "flex", flexDirection: "column"}}>
        <Button
          onClick={submitLogin}
          variant="contained"
          color="success"
          className='loginButton'
          // disabled={isLoading}
        >
          Login
        </Button>
        { showForgotPassword && <Button
          className='loginButton'
          color="success"
          onClick={() => setIsForgotPassword(true)}
        >
          Forgot Password
        </Button> }
      </div>
    </div>
  );
};

LoginTemplate.propTypes = {
  open: PropTypes.bool
};

LoginTemplate.defaultProps = {
  open: false
};

export default LoginTemplate;
